module.exports = __webpack_public_path__ + "img/instagram-logo.ea056d93.svg";